import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent, isValidElement } from 'react';
import styled, { css } from 'styled-components';
import PT from 'prop-types';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';
import { T as TooltipButton, a as TooltipIcon } from '../HelpTip/HelpTip-062d82c8.js';
import { T as Tag } from '../Tag/Tag-2f585834.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-189dc982.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-12ae0974.js';
import { i as isString } from '../LocalModules/storm-ui-utils/dist/esm/isString-c7dc7f9f-edb7f9ec.js';
import { i as isFunction } from '../LocalModules/storm-ui-utils/dist/esm/isFunction-a499fe26-1566f82d.js';

var _class;
const NodeSafeHTMLElement = typeof HTMLElement !== 'undefined' ? HTMLElement : Object;

/**
 * We want to render react nodes *OR* run a render prop function is that is what we are given.
 */
function returnElementOrRunRenderable(renderable, ...rest) {
  if ( /*#__PURE__*/isValidElement(renderable) || isString(renderable)) {
    return renderable;
  }
  if (isFunction(renderable)) {
    return renderable(...rest);
  }
  return null;
}
const LabelLine = /*#__PURE__*/styled((_class = class LabelLineComponent extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderLabelElement", ({
      useClassNameProp,
      ...extraProps
    }) => {
      const {
        labelId,
        labelFor,
        onLabelClick,
        children,
        className,
        renderLabelStart,
        renderLabelEnd,
        hidden,
        innerRef,
        taktId,
        taktValue,
        ...rest
      } = this.props;
      const labelProps = {
        ...rest,
        id: labelId,
        className: useClassNameProp ? className : undefined,
        /*
         * Only attach the click handler if the label has no id string that associates with a input.
         */
        ...(isString(labelFor) ? {
          htmlFor: labelFor
        } : {
          onClick: onLabelClick
        })
      };
      return /*#__PURE__*/React__default.createElement("label", _extends({
        ref: innerRef
      }, extraProps, labelProps), children);
    });
  }
  render() {
    const {
      className,
      renderLabelStart,
      renderLabelEnd,
      taktId,
      taktValue
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      fallbackId: createStormTaktId('label-line')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !!renderLabelStart || !!renderLabelEnd ? /*#__PURE__*/React__default.createElement("span", _extends({
      className: className
    }, getDataTaktAttributes({
      taktValue
    })), !!renderLabelStart && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, returnElementOrRunRenderable(renderLabelStart), ' '), this.renderLabelElement({
      useClassNameProp: false
    }), !!renderLabelEnd && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ' ', returnElementOrRunRenderable(renderLabelEnd))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.renderLabelElement({
      useClassNameProp: true,
      ...getDataTaktAttributes({
        taktValue
      })
    }))));
  }
}, _defineProperty(_class, "propTypes", {
  labelId: PT.string,
  labelFor: PT.string,
  className: PT.string,
  renderLabelStart: PT.oneOfType([PT.func, PT.node]),
  renderLabelEnd: PT.oneOfType([PT.func, PT.node]),
  onLabelClick: PT.func,
  children: PT.node.isRequired,
  hidden: PT.bool,
  innerRef: PT.shape({
    current: PT.instanceOf(NodeSafeHTMLElement)
  })
}), _defineProperty(_class, "defaultProps", {
  labelId: undefined,
  labelFor: undefined,
  renderLabelStart: undefined,
  renderLabelEnd: undefined,
  onLabelClick: undefined,
  hidden: false,
  className: '',
  innerRef: undefined
}), _class)).withConfig({
  componentId: "sc-storm-ui-30037988__sc-1k6rooo-0"
})(["", " & > label,label&{display:inline;padding-left:0;padding-bottom:0;", " font-weight:", ";color:", ";", "}", "{vertical-align:baseline;}", "{padding:0;}", "{margin:0;}"], ({
  hidden,
  theme
}) => hidden && theme.typography.screenReaderOnly, ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.form.label.weight, ({
  theme
}) => theme.form.label.color, isMobile(css(["", ""], ({
  theme
}) => theme.typography.mobile.base)), TooltipButton, TooltipIcon, Tag);
LabelLine.displayName = 'LabelLine';
var LabelLine$1 = LabelLine;

export { LabelLine$1 as L };
//# sourceMappingURL=LabelLine-f40c5f5f.js.map
